// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ActionLeague":"ActionLeague-3ohhWvO0","slideItem":"slideItem-3XW2La_c","last":"last-1qT1Kour slideItem-3XW2La_c","text_wrap":"text_wrap-1rc7qHZt"};